import { type Ref, computed, onMounted, ref, watch } from "vue";

import { Ripple } from "@/shared/ui/Ripple";

type RippleEffectConfig = {
    elementRef?: Ref<HTMLElement | null>;
    selector?: string;
    disabled?: Ref<boolean>;
    animationDurationSec?: number;
};

export default function useRippleEffect(config: RippleEffectConfig) {
    // define html refs
    const elementRef = config.elementRef || ref<HTMLElement | null>(null);
    const selector = config.selector || undefined;
    const disabled = config.disabled || ref(false);
    const animationDurationSec = config.animationDurationSec || 0.6;
    const jQueryElement = computed(() => $(elementRef.value as any));
    let isInitialized = false;

    function initialize() {
        Ripple.bind(jQueryElement.value, selector, animationDurationSec);
        isInitialized = true;
    }

    // define watch
    watch(
        () => disabled.value,
        (disabled) => {
            if (disabled) {
                Ripple.unbind(jQueryElement.value);
            } else {
                Ripple.bind(jQueryElement.value, selector, animationDurationSec);
            }
        }
    );

    // if element is there - initialize
    if (jQueryElement.value.length) {
        initialize();
    }

    // define onMounted
    onMounted(() => {
        if (!isInitialized && !disabled.value && jQueryElement.value.length) {
            initialize();
        }
    });

    return {
        elementRef,
    };
}
